// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__21N41","itemTitle":"ClientEmergencyInfo_itemTitle__38sM2","itemText":"ClientEmergencyInfo_itemText__WO3vs"};